var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"spinner",attrs:{"width":`${_vm.size}px`,"height":`${_vm.size}px`,"viewBox":`0 0 ${_vm.size} ${_vm.size}`,"xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{staticClass:"path",attrs:{"fill":"none","stroke-width":_vm.borderWidth,"stroke-linecap":"round","cx":_vm.halfSize,"cy":_vm.halfSize,"r":_vm.radius}})])
}
var staticRenderFns = []

export { render, staticRenderFns }